import { c as _c } from "react/compiler-runtime";
import { Badge } from "@shared-components/shadcn/badge";
import { cn } from "@shared-utils/ui";
import { CircleX } from "lucide-react";
import { type ReactNode } from "react";
interface DepartmentBadgeProps {
  onClick: () => void;
  children: string | ReactNode;
}
export const DepartmentBadge = props => {
  const $ = _c(11);
  let t0;
  if ($[0] !== props) {
    t0 = e => {
      if (props.onClick) {
        e.preventDefault();
        e.stopPropagation();
        props.onClick();
      }
    };
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const t1 = Boolean(props.onClick);
  let t2;
  if ($[2] !== t1) {
    t2 = cn("facet-badge relative m-0.5 mt-1 p-2 whitespace-nowrap", {
      "cursor-pointer": t1
    });
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== props.onClick) {
    t3 = Boolean(props.onClick) && <CircleX className="ml-1" size={14} />;
    $[4] = props.onClick;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== props.children || $[7] !== t0 || $[8] !== t2 || $[9] !== t3) {
    t4 = <Badge size="lg" variant="default" onClick={t0} className={t2}>{props.children}{t3}</Badge>;
    $[6] = props.children;
    $[7] = t0;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
};